'use strict';

/**
 * Integromat Forman
 *
 * @license Copyright (c) Integromat - All rights reserved.
 * @version __VERSION__
 */

if (!window.imt) {
	window.imt = {};
}

if (!window.imt.plugins) {
	window.imt.plugins = [];
}

if (!window.imt.user) {
	window.imt.user = {};
}


imt.plugins.push({
	name: 'Forman',
	version: '__VERSION__',
});

/**
 * Polyfills for the browser.
 */


/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */

if (!Element.prototype.matches) {
	Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

/**
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
 */

if (!Element.prototype.closest) {
	Element.prototype.closest = function closest(s) {
		let el = this;

		if (!document.documentElement.contains(el)) return null;
		do {
			if (el.matches(s)) return el;
			el = el.parentElement || el.parentNode;
		} while (el !== null && el.nodeType === 1);
		return null;
	};
}

// Polyfill for custom elements
import '@webcomponents/custom-elements';

// Polyfill for ResizeObserver
import ResizeObserver from 'resize-observer-polyfill';

if (!window.ResizeObserver) window.ResizeObserver = ResizeObserver;

// Polyfill for String.prototype.normalize
import 'unorm';

// Polyfill for :scope in querySelector and querySelectorAll mehtods (IE)
import 'element-qsa-scope';

// Polyfill for CustomEvent (IE)
import 'custom-event-polyfill';

// Autosize for text areas
import autosize from 'autosize';

window.autosize = autosize;
